export const elenPreJobInteractions = [
    {
        id: 1,
        label: 'Do you have any jobs available?',
        disabled: false
    },
    {
        id: 2,
        label: 'I want to buy something.',
        disabled: false
    }
]

export const elenMainInteractions = [
    {
        id: 2,
        label: 'I want to buy something',
        disabled: false
    },
    {
        id: 3,
        label: 'I want to work (20$)',
        disabled: false
    },
    {
        id: 4,
        label: 'I want to work (double shift 40$)',
        disabled: false
    },
    {
        id: 5,
        label: '(Interact...)',
        disabled: false
    }
]

export const elenHomeInteractions = [
    {
        id: 6,
        label: 'Talk',
        disabled: false
    },
    {
        id: 7,
        label: '(Interact...)',
        disabled: true
    },
    {
        id: 8,
        label: 'Make Love',
        disabled: true
    },
    {
        id: 9,
        label: 'Date',
        disabled: true
    }
]

export const elenSexInteractions = [
    {
        id: 10,
        label: 'Blowjob',
        disabled: false
    },
    {
        id: 11,
        label: 'Doggystyle',
        disabled: false
    },
]

export const elenDateInteractions = [
    {
        id: 12,
        label: 'Beach',
        disabled: true
    },
]
